import { render, staticRenderFns } from "./SuperGraphicsFrame.vue?vue&type=template&id=2e312627&scoped=true&"
import script from "./SuperGraphicsFrame.vue?vue&type=script&lang=js&"
export * from "./SuperGraphicsFrame.vue?vue&type=script&lang=js&"
import style0 from "./SuperGraphicsFrame.vue?vue&type=style&index=0&id=2e312627&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e312627",
  null
  
)

export default component.exports